import stateMaps from 'ee/vue_merge_request_widget/stores/state_maps';

export default stateMaps;
